import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { CrmHelpdeskAiContentPage } from '@pages/crm';

export const Route = createFileRoute(
  '/$locale/_authenticated/crm/helpdesk/instructions/$instructionId'
)({
  params: z.object({ instructionId: z.uuid() }),
  component: ContentDetailRoute,
});
function ContentDetailRoute() {
  const { locale, instructionId } = Route.useParams();
  return (
    <CrmHelpdeskAiContentPage
      locale={locale}
      kind="instructions"
      id={instructionId}
      search={Route.useSearch()}
    />
  );
}
